export default "__VITE_ASSET__fd41a188__"